module.exports = __webpack_public_path__ + "img/leaves-back-2x.6e13de97.png";